import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features241.css'

const Features241 = (props) => {
  return (
    <div id={props.features241Id} className="thq-section-padding">
      <div className="features241-container2 thq-section-max-width">
        <div className="features241-image-container">
          <img
            alt={props.feature1ImgAlt}
            src={props.feature1ImgSrc}
            className="features241-image1 thq-img-ratio-16-9"
          />
        </div>
        <div className="features241-tabs-menu">
          <div className="features241-tab-horizontal1">
            <div className="features241-divider-container1">
              <div className="features241-container3"></div>
            </div>
            <div className="features241-content1">
              <h2 className="thq-heading-2">
                {props.feature1Title ?? (
                  <Fragment>
                    <span className="features241-text2">
                      Personalized Training Programs
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {props.feature1Description ?? (
                  <Fragment>
                    <span className="features241-text1">
                      Tailored training programs designed to meet individual
                      fitness goals.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="features241-tab-horizontal2">
            <div className="features241-divider-container2">
              <div className="features241-container4"></div>
            </div>
            <div className="features241-content2">
              <span className="thq-body-small">
                {props.feature2Description ?? (
                  <Fragment>
                    <span className="features241-text3">
                      Expert advice on nutrition to complement and enhance
                      fitness results.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features241.defaultProps = {
  feature1Description: undefined,
  feature1ImgAlt: 'Personalized Training Programs Image',
  features241Id: '',
  feature1ImgSrc:
    'https://images.unsplash.com/photo-1655842556575-e8c871982258?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQwNjUxNXw&ixlib=rb-4.0.3&q=80&w=1080',
  feature1Title: undefined,
  feature2Description: undefined,
}

Features241.propTypes = {
  feature1Description: PropTypes.element,
  feature1ImgAlt: PropTypes.string,
  features241Id: PropTypes.string,
  feature1ImgSrc: PropTypes.string,
  feature1Title: PropTypes.element,
  feature2Description: PropTypes.element,
}

export default Features241
